import React from "react";
import Desplegable from "../../desplegable";
import Cargos from "../../cargos/Cargos";
export const DesplegableRepresentantesLegales = (props) => {
  return (
    <Desplegable
      eventKey="3"
      id="3"
      Toogle="Representantes legales"
      handleButtonShow={props.handleButtonShow}
      showModal={props.state.showModalArray[3]}
      Text={<Cargos type={props.DireccionGeneral ? "rlGeneral" : "rlProvincial"} idEntidad={props.id_provincia} />}
    />
  );
};
